/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IDlvryAuthenticatedContainerData } from './dlvry-authenticated-container.data';
import { IDlvryAuthenticatedContainerProps } from './dlvry-authenticated-container.props.autogenerated';

export interface IDlvryAuthenticatedContainerViewProps extends IDlvryAuthenticatedContainerProps<IDlvryAuthenticatedContainerData> {}

/**
 *
 * DlvryAuthenticatedContainer component
 * @extends {React.PureComponent<IDlvryAuthenticatedContainerProps<IDlvryAuthenticatedContainerData>>}
 */
class DlvryAuthenticatedContainer extends React.PureComponent<IDlvryAuthenticatedContainerProps<IDlvryAuthenticatedContainerData>> {
    public render(): JSX.Element | null {
        const { context, slots } = this.props;
        const { isEditor } = context.request.params;
        const { authenticatedContent, unauthenticatedContent } = slots;

        const isAuthenticated = context.request.user.isAuthenticated;

        return (
            <>
                {isEditor ? (
                    <>
                        {authenticatedContent}
                        {unauthenticatedContent}
                    </>
                ) : isAuthenticated ? (
                    authenticatedContent
                ) : (
                    unauthenticatedContent
                )}
            </>
        );
    }
}

export default DlvryAuthenticatedContainer;
